import { z } from 'zod/v4'
import { WorkflowNodeBaseSchema } from '../../../resources/types'

// Input validation schema
const FunctionInvokeInputsSchema = z.object({
  code: z
    .string()
    .describe('The code to execute (may contain liquid templates)'),
  handle: z.string().describe('The function handle identifier'),
  inputs: z
    .record(z.string(), z.unknown())
    .optional()
    .describe('Input parameters to pass to the function'),
})

// Options schema
const FunctionInvokeOptionsSchema = z.object({
  runtime: z.string().describe('The runtime environment (e.g., node:22)'),
  timeout: z.number().optional().describe('Timeout in milliseconds'),
})

// Export the command schema
export const FunctionInvokeCommandSchema = WorkflowNodeBaseSchema.extend({
  service: z.object({
    name: z.literal('skedyul/compute'),
    cmd: z.literal('function.invoke'),
    options: FunctionInvokeOptionsSchema.optional(),
    env: z
      .record(z.string(), z.string())
      .optional()
      .describe('Environment variables (may contain liquid templates)'),
  }),
  inputs: FunctionInvokeInputsSchema,
})

export type FunctionInvokeCommand = z.infer<typeof FunctionInvokeCommandSchema>

export type FunctionInvokePayload = {
  code: string
  env: Record<string, string>
  handle: string
  runtime: string
  timeout?: number
}

export type FunctionInvokeResult = {
  cost: {
    memory: number
    time: number
  }
  response: Record<string, unknown> | undefined
  error: string | undefined
  logs: string[]
}
